<template>
  <div class="address-list">
    <div
      class="address-item"
      v-for="(item, index) in $t('addressList')"
      :key="index"
    >
      <h3>{{ item.name }}</h3>
      <p class="position">{{ item.address }}</p>
      <p class="position">{{ item.address1 }}</p>
      <div class="contact">
        <template v-if="item.tel && item.tel.length > 0">
          <p
            class="tel"
            v-for="(tel, telIndex) in item.tel"
            :key="telIndex + 'tel'"
          >
            <i></i>
            {{ tel }}
          </p>
        </template>
        <template v-if="item.fax && item.fax.length > 0">
          <p
            class="fax"
            v-for="(fax, faxIndex) in item.fax"
            :key="faxIndex + 'fax'"
          >
            <i></i>
            {{ fax }}
          </p>
        </template>
        <template v-if="item.email && item.email.length > 0">
          <p
            class="email"
            v-for="(email, emailIndex) in item.email"
            :key="emailIndex + 'email'"
          >
            <i></i>
            {{ email }}
          </p>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'addressList',
  data() {
    return {}
  }
}
</script>

<style scoped lang="scss">
//address-list
.address-list {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  .address-item {
    flex: 1 0 190px;
    h3 {
      @extend .semibold-16px;
    }
    p {
      @extend .regular-14px;
    }
    .position {
      margin: 16px 0;
      white-space: pre-line;
    }
    .contact {
      p {
        display: flex;
        align-items: center;
        i {
          display: block;
          flex: 0 0 14px;
          width: 14px;
          height: 14px;
          background: no-repeat center center / contain;
          margin-right: 7px;
        }
      }
      .tel i {
        background-image: url(~@/assets/images/i-tel.png);
      }
      .fax i {
        background-image: url(~@/assets/images/i-fax.png);
      }
      .email i {
        background-image: url(~@/assets/images/i-email.png);
      }
    }
  }
}
@media only screen and (max-width: 767px) {
  .address-list {
    flex-wrap: wrap;
  }
  .address-list .address-item {
    flex: 1 0 50%;
    margin-bottom: 20px;
  }
}
</style>
